<template>
  <SettingsPageFull>
    <template #title>
      <div class="flex space-x-3">
        <font-awesome-icon :icon="['fal', 'piggy-bank']" size="2x" />
        <span class="text-2xl font-bold capitalize-first">
          {{ $t('navigation.content_bank_title') }}
        </span>
      </div>
    </template>

    <template #cta>
      <BaseButton
        v-if="$can('manage_content')"
        color="primary"
        icon="plus"
        :title="$t('button.add_new_m', { var: $t('global.bank_account') })"
        @click="this.$router.push({ name: 'settings_create_bank_route' })"
      />
    </template>

    <template #body>
      <BaseContentTable
        v-if="metadata.columns || loading"
        :columns="metadata.columns ?? []"
        :loading="loading"
        :modelList="banksList"
        :search="true"
        @rowClick="redirectToModelPage"
        @refreshClick="withLoading(fetchBankList())"
        @deleteModel="deleteBank"
        :isHoverable="true"
      />
    </template>
  </SettingsPageFull>
</template>

<script>
import loadingMixin from '@u/mixins/loading.mixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TheBankAccountIndexPage',
  mixins: [loadingMixin],
  computed: {
    ...mapGetters({
      banksList: 'bank/getBanksList',
      metadata: 'bank/getBankMetadata'
    })
  },
  methods: {
    ...mapActions({
      fetchBankList: 'bank/fetchBankList',
      deleteBankById: 'bank/deleteBankById',
      undoDeleteBankById: 'bank/undoDeleteBankById'
    }),
    redirectToModelPage(id) {
      this.$router.push({
        name: 'settings_edit_bank_route',
        params: { id: id }
      })
    },
    deleteBank(id) {
      this.deleteBankById({
        id: id
      }).then(() => {
        this.$h.toastAction(
          'delete',
          this.$t('toasts.deleted_m', { var: this.$t('attributes.bank') }),
          null,
          [
            {
              title: this.$t('button.cancel'),
              class: 'text-red-700',
              action: () => this.undoDeleteBank(id)
            }
          ]
        )
      })
    },
    undoDeleteBank(id) {
      this.undoDeleteBankById({
        id: id
      }).then(() => {
        this.$h.toastSuccess(
          this.$t('toasts.reseted_m', { var: this.$t('attributes.bank') })
        )
      })
    }
  },
  beforeMount() {
    this.withLoading(this.fetchBankList())
  }
}
</script>
